import { GlobalWorkerOptions, getDocument, type PDFDocumentProxy } from "pdfjs-dist";
import workerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

let ready = false;

function ensurePdfWorker(): void {
  if (ready) return;
  GlobalWorkerOptions.workerSrc = workerUrl;
  ready = true;
}

export async function loadPdfFromUrl(url: string): Promise<PDFDocumentProxy> {
  ensurePdfWorker();
  const res = await fetch(url, { credentials: "include", cache: "no-store" });
  if (!res.ok) throw new Error("PDF introuvable.");
  const data = await res.arrayBuffer();
  return getDocument({ data }).promise;
}
